import vue from "vue";

export default {
    SET_DURATION: (state, duration) => {
        state.duration = duration;
    },
}
